import React, { useEffect, useMemo, useState } from "react";
import { supabase } from "../Services/supabaseClient";
import { useCompany } from "../context/CompanyContext";
import "../Product/customers.css";

export default function StockAgeingReport() {
  const { companyId } = useCompany();
  const [rows, setRows] = useState([]);

  useEffect(() => {
    (async () => {
      if (!companyId) return;
      const { data } = await supabase
        .from("stock_ageing_report")
        .select("*")
        .eq("company_id", companyId)
        .order("age_days", { ascending: false });
      setRows(data || []);
    })();
  }, [companyId]);

  const totals = useMemo(() => {
    const t = {};
    for (const r of rows) {
      const b = r.age_bucket || "unknown";
      t[b] = (t[b] || 0) + Number(r.value || 0);
    }
    return t;
  }, [rows]);

  return (
    <div className="customers-container">
      <header className="cust-head panel">
        <div style={{ fontWeight: 900 }}>Stock Ageing (FIFO Layers)</div>
        <div className="muted" style={{ marginTop: 6 }}>
          Buckets total:{" "}
          {Object.entries(totals)
            .map(([k, v]) => `${k}: ₦${Number(v).toLocaleString()}`)
            .join(" • ")}
        </div>
      </header>

      <section className="panel table-panel">
        <div className="table-wrap">
          <table className="customer-table">
            <thead>
              <tr>
                <th>Warehouse</th>
                <th>SKU</th>
                <th>Item</th>
                <th>Received</th>
                <th>Bucket</th>
                <th className="num">Qty</th>
                <th className="num">Unit cost</th>
                <th className="num">Value</th>
                <th className="num">Age (days)</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((r, i) => (
                <tr key={`${r.item_id}-${r.received_date}-${i}`}>
                  <td>{r.warehouse_name || "—"}</td>
                  <td>{r.sku}</td>
                  <td>{r.item_name}</td>
                  <td>{r.received_date}</td>
                  <td>
                    <span className="chip">{r.age_bucket}</span>
                  </td>
                  <td className="num">{Number(r.remaining_qty || 0)}</td>
                  <td className="num">
                    {Number(r.unit_cost || 0).toLocaleString()}
                  </td>
                  <td className="num">
                    ₦{Number(r.value || 0).toLocaleString()}
                  </td>
                  <td className="num">{Number(r.age_days || 0)}</td>
                </tr>
              ))}
            </tbody>
          </table>

          {!rows.length && (
            <div className="empty-state">
              <p>No ageing rows.</p>
            </div>
          )}
        </div>
      </section>
    </div>
  );
}
